resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    Manages the steps (sections) in a form.
    - Manages the showing of steps in a form
    - Keeps track of completed steps and incomplete steps
    - Allows editing of completed steps, returns form to next incomplete step after edits
*/
function FormWizardHelper() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.extends = [_ResponsiveLayout];

    this.currentFormStep = 1;
    this.openedFormStep = 1;
    this.editFormStep = null;

    // No parameters

    this.init = function() {
        $(this.node).css("display", "block");

        // Responsive
        this.registerResponsiveFunction($.proxy(this._onResizeCheck, this, true), null, 1024);
        this.registerResponsiveFunction($.proxy(this._onResizeCheck, this, false), 1025, null);
    };

    this.initAllReady = function() {
        var sectionsContent = $(".sections .section-content", this.node);
        $(sectionsContent[0]).slideDown(325);
        $(window).trigger("resize");
    };

    /*
        Show a section of a form
    */
    this.showFormSection = function(section) {
        var index = section - 1;
        this.openedFormStep = section;
        var sectionsContent = $(".sections .section-content", this.node);
        var sections = $(".sections .section", this.node);
        for (var i = 0; i < sections.length; i++) {
            if (i == index) {
                $(sectionsContent[i]).slideDown(325);
                $("h2", sections[i]).animate({opacity: 1}, {duration: 325});
                $(".section-summary", sections[i]).slideUp(325);
                $(".circle", sections[i]).fadeIn(325);
                $(".icon-check", sections[i]).fadeOut(325);
                $(".icon--edit", sections[i]).fadeOut(325);
            } else {
                $(sectionsContent[i]).slideUp(325);
                if ((i + 1) < this.currentFormStep) {
                    // Completed step
                    $(".section-summary", sections[i]).slideDown(325);
                    $(".circle", sections[i]).fadeOut(325);
                    $(".icon-check", sections[i]).fadeIn(325);
                    $(".icon--edit", sections[i]).fadeIn(325);
                    if (this.openedFormStep < this.currentFormStep)
                        $(".icon--edit", sections[i]).addClass("disabled");
                    else
                        $(".icon--edit", sections[i]).removeClass("disabled");
                } else {
                    $("h2", sections[i]).animate({opacity: 0.4}, {duration: 325});
                }
            }
        }
    };

    /*
        Edit a section of a form.
        Cannot edit a section that was not previously completed.
    */
    this.editFormSection = function(section) {
        // Disable editing if editing another step
        if (this.openedFormStep < this.currentFormStep) {
            return false;
        }

        // Can only edit completed steps
        if (section < this.currentFormStep) {
            this.editFormStep = section;
            this.showFormSection(section);
            return true;
        }

        return false;
    };

    /*
        Mark step as complete.
        Advance to specified step (must be a already completed step), or
        advance to the next incomplete step (default).
    */
    this.completeFormSection = function(section, advanceTo, disableScroll) {
        var sections = $(".section", this.node);
        var slideTo = null;

        // Complete section
        $(sections[section - 1]).addClass("complete");
        setTimeout($.proxy(function() {
            $("button", sections[section - 1]).html("Done");
        }, this), 325);

        if (section == this.currentFormStep) {
            // Completing a current section
            if (this.currentFormStep != sections.length) {
                this.currentFormStep++;

                // Show next section
                if (advanceTo != null && !isNaN(parseInt(advanceTo)) && parseInt(advanceTo) < this.currentFormStep) {
                    this.showFormSection(parseInt(advanceTo));
                    this.editFormStep = advanceTo;
                    slideTo = advanceTo;
                } else {
                    this.showFormSection(this.currentFormStep);
                    this.editFormStep = null;
                    slideTo = this.currentFormStep;
                }
            }
        } else if (this.editFormStep != null) {
            // Completing an editing section
            if (advanceTo != null && !isNaN(parseInt(advanceTo)) && parseInt(advanceTo) < this.currentFormStep) {
                this.showFormSection(advanceTo);
                this.editFormStep = advanceTo;
                slideTo = advanceTo;
            } else {
                this.showFormSection(this.currentFormStep);
                this.editFormStep = null;
                slideTo = section + 1;
            }
        }

        // Slide page
        if (disableScroll != true) {
            if (this._isMobile || this.currentFormStep == sections.length) {
                if ((slideTo - 1) > section) {
                    setTimeout($.proxy(function () {
                        var slideToPx = $(sections[slideTo - 2]).offset().top - $("#Navigation").outerHeight() - 25; // 25 padding
                        $("html, body").animate({scrollTop: slideToPx + "px"}, {duration: 325});
                    }, this), 325);
                } else {
                    var slideToPx = $(sections[slideTo - 2]).offset().top - $("#Navigation").outerHeight() - 25; // 25 padding
                    $("html, body").animate({scrollTop: slideToPx + "px"}, {duration: 325});
                }
            }
        }
    };

    this._onResizeCheck = function(isMobile) {
        this._isMobile = isMobile;
    };
}